import { AxiosResponse } from 'axios';
import { FeatureFlagsPayload } from 'src/store/userSlice';
import apiClient from 'src/utils/apiClient';

const getFeatureFlags = async (): Promise<AxiosResponse<FeatureFlagsPayload, any>> => {
  return await apiClient.get<FeatureFlagsPayload>('/featureFlags').catch(() => ({
    // in case this endpoint is down, use the below hardcoded values
    data: {
      placement_transfer: true,
      decision_portal: true,
      atoz_notifications: true,
      job_modifications: true,
      correspondence: true,
      persona: false,
    },
    status: 200,
    statusText: 'OK',
    headers: {},
    config: {},
  }));
};

const updateFeatureFlag = async (featureName: string, isEnabled: boolean) => {
  return await apiClient.put<FeatureFlagsPayload>(`/featureFlags/${featureName}?enabled=${isEnabled}`);
};

export default { getFeatureFlags, updateFeatureFlag };
